import React, { createContext, useContext, useState, useEffect } from 'react';


const WizardContext = createContext();
 
export const WizardProvider = ({children}) => {
    const [currentStep, setCurrentStep] = useState(1)
    const [formData, updateFormData] = useState(null)
    const [calendarSubStep, setCalendarSubStep] = useState(1)
    
    const resetAll = () => {
      setCurrentStep(1)
      updateFormData(null)
      setCalendarSubStep(1)
    }

    const setCustomStep = (num) => {
      setCurrentStep(num)
    }

    const nextStep = () => {
      const nextStep = currentStep + 1
      setCurrentStep(nextStep)
    }

    const previousStep = () => {
      const prevStep = currentStep - 1
      setCurrentStep(prevStep)
    }

    const nextCalendarSubStep = () => {
      const subStep = Math.max(1, calendarSubStep + 1)
      setCalendarSubStep(subStep)
    }
    const previousCalendarSubStep = () => {
      const subStep = Math.max(1, calendarSubStep - 1)
      setCalendarSubStep(subStep)
    }
    const resetCalendarSubSteps = () => setCalendarSubStep(1)

    return (
        <WizardContext.Provider value={{ 
            currentStep, 
            setCurrentStep, 
            formData, 
            updateFormData,
            nextStep,
            previousStep,
            currentStep,
            resetCalendarSubSteps,
            nextCalendarSubStep,
            previousCalendarSubStep,
            calendarSubStep,
            resetAll,
            setCustomStep
        }}>
          {children}
        </WizardContext.Provider>
      );
}


export const useWizard = () => {
    const context = useContext(WizardContext);
    if (!context) {
      throw new Error('getWizard must be used within WizardProvider');
    }
    return context;
};

